<div class="appliance-cameras-container">
  <div class="appliance-camera-header">
    <div class="cameras-count">{{ 'appliances.labels.camerasCount' | t:{ count: list.dataSource.data.length } }}</div>
    <div class="appliance-cameras-bulk-actions">
      <button
        mat-button
        color="danger"
        type="button"
        *ngIf="!isEditedCameras() && !isLoading"
        (click)="discardChanges()"
      >
        {{ 'appliances.actions.discardChanges' | t }}
      </button>
      <sn-flat-button
        color="success"
        [disabled]="isEditedCameras()"
        (click)="publishChanges()"
        [isLoading]="isLoading"
      >
        {{ 'appliances.actions.publishChanges' | t }}
      </sn-flat-button>
    </div>
  </div>

  <div class="appliance-camera-body-data">
    <sn-data-list
      #listElement
      reloadByQueryParams
      [class.sn-data-list--with-add-button]="false"
      [fetchFn]="fetchFn"
      [feedFn]="feedFn"
    >
      <sn-infinite-scroll windowScrollTarget>
        <sn-pull-to-refresh>
          <ng-template [ngIf]="list.dataSource.data.length" [ngIfThen]="table"></ng-template>
          <ng-template
            [ngIf]="!list.dataSource.data.length && list.dataIsInited"
            [ngIfThen]="emptyList"
          ></ng-template>
        </sn-pull-to-refresh>
      </sn-infinite-scroll>
    </sn-data-list>

    <ng-template #table>
      <mat-table
        [dataSource]="list.dataSource.data"
        [trackBy]="trackBy"
        multiTemplateDataRows
        matSort
        matSortDisableClear
        [matSortActive]="sort"
        [matSortDirection]="sortDirection"
        (matSortChange)="onSortChange($event)"
      >
        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'common.name' | t }}</mat-header-cell>
          <mat-cell *matCellDef="let camera">
            <span class="fs-text-truncate">{{ camera.name }}</span>
          </mat-cell>
        </ng-container>

        <!-- Make Column -->
        <ng-container matColumnDef="make">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'appliances.labels.make' | t }}</mat-header-cell>
          <mat-cell *matCellDef="let camera">
            <span class="fs-text-truncate">{{ camera.make }}</span>
          </mat-cell>
        </ng-container>

        <!-- Model Column -->
        <ng-container matColumnDef="model">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'common.model' | t }}</mat-header-cell>
          <mat-cell *matCellDef="let camera">
            <span class="fs-text-truncate">{{ camera.model }}</span>
          </mat-cell>
        </ng-container>

        <!-- Status Column -->
        <ng-container matColumnDef="status">
          <mat-header-cell *matHeaderCellDef mat-sort-header="status_repr_db"
            >{{ 'common.status' | t }}</mat-header-cell
          >
          <mat-cell *matCellDef="let camera">
            <fs-appliance-camera-status
              *ngIf="camera.status"
              [status]="camera.status"
            ></fs-appliance-camera-status>
          </mat-cell>
        </ng-container>

        <!-- Bandwidth Column -->
        <ng-container matColumnDef="bandwidth">
          <mat-header-cell *matHeaderCellDef>{{ 'appliances.labels.bandwidth' | t }}</mat-header-cell>
          <mat-cell *matCellDef="let camera">
            <ng-container
              *ngIf="
                bandwidths[camera.id] !== null && bandwidths[camera.id] !== undefined;
                else noBandwidth
              "
            >
              <span class="fs-text-truncate">{{ formatBandwidth(bandwidths[camera.id]) }}</span>
            </ng-container>
            <ng-template #noBandwidth>
              <span [matTooltip]="'appliances.labels.notAvailable' | t">-</span>
            </ng-template>
          </mat-cell>
        </ng-container>

        <!-- Quality Column -->
        <ng-container matColumnDef="quality">
          <mat-header-cell *matHeaderCellDef>{{ 'appliances.labels.quality' | t }}</mat-header-cell>
          <mat-cell *matCellDef="let camera">
            <ng-container *ngIf="getQualityOptions(camera.id)?.length; else noQuality">
              <mat-form-field>
                <mat-select
                  [value]="getCameraQuality(camera.id, camera.path)"
                  (selectionChange)="onQualityChange(camera.id, $event.value)"
                >
                  <mat-option
                    *ngFor="let quality of getQualityOptions(camera.id)"
                    [value]="quality"
                  >
                    {{ quality }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </ng-container>
            <ng-template #noQuality>
              <span [matTooltip]="'appliances.labels.notAvailable' | t">-</span>
            </ng-template>
          </mat-cell>
        </ng-container>

        <!-- Recording Column -->
        <ng-container matColumnDef="recording">
          <mat-header-cell *matHeaderCellDef>{{ 'appliances.labels.recording' | t }}</mat-header-cell>
          <mat-cell *matCellDef="let camera">
            <mat-slide-toggle
              [checked]="camera.record"
              (change)="onRecordChange(camera.id, $event.checked)"
            ></mat-slide-toggle>
          </mat-cell>
        </ng-container>

        <!-- Video Retention Column -->
        <ng-container matColumnDef="videoRetention">
          <mat-header-cell *matHeaderCellDef>{{ 'appliances.labels.setRetention' | t }}</mat-header-cell>
          <mat-cell *matCellDef="let camera">
            <ng-container *ngIf="isVideoRetentionEnabledForCamera(camera); else noRetention">
              <mat-form-field>
                <mat-select
                  [placeholder]="
                    getRetentionDays(camera) === 0
                      ? '< 1 day'
                      : getRetentionDays(camera) > 90
                      ? '> 90 days'
                      : ''
                  "
                  [value]="getRetentionDays(camera)"
                  [disabled]="!isVideoRetentionEnabledForCamera(camera)"
                  (selectionChange)="onLoopDurationChange(camera.id, $event.value)"
                >
                  <mat-option *ngFor="let day of retentionDaysOptions" [value]="day">
                    {{ day }} {{ day === 1 ? 'day' : 'days' }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </ng-container>
            <ng-template #noRetention>
              <span [matTooltip]="'appliances.labels.notAvailable' | t">-</span>
            </ng-template>
          </mat-cell>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef>{{ 'appliances.table.actions' | t }}</mat-header-cell>
          <mat-cell *matCellDef="let camera">
            <sn-action-list
              [items]="actions"
              [context]="camera"
              [strictCollapse]="true"
            ></sn-action-list>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: columns"></mat-row>
      </mat-table>
    </ng-template>

    <ng-template #emptyList>
      <sn-empty-state icon="cancel_presentation" [title]="'common.noResults' | t">
        {{ 'common.noResultsMatchSearch' | t }}
      </sn-empty-state>
    </ng-template>
  </div>
</div>
